<!--div class="modal-header">
  <h4 class="modal-title">Hi there!</h4>
</div-->
<div class="modal-body" *ngIf="confirmationDesc !== null">
  <p>{{ confirmationDesc }}</p>
</div>
<div class="modal-footer justify-content-center">
  <button type="button" class="btn btn-secondary"
          *ngIf="cancelButtonText !== null"
          (click)="activeModal.close(false)">
    {{ cancelButtonText }}
  </button>
  <button type="button" class="btn btn-primary"
          *ngIf="validateButtonText !== null"
          (click)="activeModal.close(true)">
    {{ validateButtonText }}
  </button>
</div>
